/**
 * TIPS AND TRICKS FOR CONTRIBUTORS
 * 1) Memorize the layering of body parts. Hands are higher than arms, feet higher than legs
 * 2) Generally you will want to avoid lower pri items on the same layer sticking out on seams if your object is skintight.
 * In general, this is accomplished by having higher priority items cover more of the original
 */


AddModel({
	Name: "Petsuit",
	Folder: "Petsuit",
	Parent: "Petsuit",
	TopLevel: true,
	Categories: ["Restraints", "Cosplay"],
	Restraint: true,
	AddPose: ["HideArms", "EncaseArmLeft", "EncaseArmRight", "EncaseLegLeft", "EncaseLegRight", "ForceKneel", "Petsuit"],
	HideLayerGroups: ["PetsuitArms"],
	Layers: ToLayerMap([
		{ Name: "Arms", Layer: "BindForeArms", Pri: -30,
			Invariant: true,
			Poses: ToMap(["Front"]),
		},
		{ Name: "ArmsBelts", Layer: "BindForeArms", Pri: -29.9,
			Invariant: true,
			TieToLayer: "Arms",
			NoOverride: true,
			Poses: ToMap(["Front"]),
		},
		{ Name: "Legs", Layer: "PetsuitLegsRight", Pri: -5,
			Poses: ToMap(["KneelClosed", "Kneel", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
		},
		{ Name: "LegsBelts", Layer: "PetsuitLegsRight", Pri: -4.9,
			TieToLayer: "Legs",
			NoOverride: true,
			Poses: ToMap(["KneelClosed", "Kneel", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
		},
		{ Name: "LeftLegs", Layer: "PetsuitLegs", Pri: -5,
			Poses: ToMap(["KneelClosed", "Kneel"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			InheritColor: "Legs",
			DisplaceAmount: 50,
			DisplacementInvariant: true,
			DisplaceLayers: ToMap(["Petsuit"]),
			DisplacementSprite: "PetsuitSquish",
		},
		{ Name: "LeftLegsBelts", Layer: "PetsuitLegs", Pri: -4.9,
			TieToLayer: "LeftLegs",
			NoOverride: true,
			Poses: ToMap(["KneelClosed", "Kneel"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			InheritColor: "LegsBelts",
		},
	])
});


AddModel({
	Name: "LatexPetsuit",
	Folder: "LatexPetsuit",
	Parent: "Petsuit",
	TopLevel: true,
	Categories: ["Restraints", "Cosplay"],
	Restraint: true,
	AddPose: ["HideArms", "EncaseArmLeft", "EncaseArmRight", "EncaseLegLeft", "EncaseLegRight", "ForceKneel", "Petsuit"],
	HideLayerGroups: ["PetsuitArms"],
	Layers: ToLayerMap([
		{ Name: "Arms", Layer: "BindForeArms", Pri: -41,
			Invariant: true,
			Poses: ToMap(["Front"]),
		},
		{ Name: "Butt", Layer: "PetsuitLegsUnder", Pri: -16,
			Poses: ToMap(["KneelClosed", "Kneel"]),
			InheritColor: "Legs",
		},
		{ Name: "Legs", Layer: "PetsuitLegsRight", Pri: -16,
			Poses: ToMap(["KneelClosed", "Kneel", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
		},
		{ Name: "LeftLegs", Layer: "PetsuitLegs", Pri: -16,
			Poses: ToMap(["KneelClosed", "Kneel"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			InheritColor: "Legs",
			DisplaceAmount: 50,
			DisplacementInvariant: true,
			DisplaceLayers: ToMap(["Petsuit"]),
			DisplacementSprite: "PetsuitSquish",
		},
	])
});

AddModel({
	Name: "LatexPetsuitGlow",
	Folder: "LatexPetsuit",
	Parent: "Petsuit",
	TopLevel: false,
	Categories: ["Restraints", "Cosplay"],
	Restraint: true,
	AddPose: ["HideArms", "EncaseArmLeft", "EncaseArmRight", "EncaseLegLeft", "EncaseLegRight", "ForceKneel", "Petsuit"],
	HideLayerGroups: ["PetsuitArms"],
	Layers: ToLayerMap([
		...GetModelLayers("LatexPetsuit"),
		{ Name: "GlowArms", Layer: "BindForeArms", Pri: -40,
			Invariant: true,
			Poses: ToMap(["Front"]),
			InheritColor: "Glow",
			NoOverride: true,
			NoDisplace: true,
		},
		{ Name: "GlowTorso", Layer: "WrapChest", Pri: -40,
			Invariant: true,
			InheritColor: "GlowTorso",
			NoOverride: true,
			NoDisplace: true,
		},
		{ Name: "GlowLegs", Layer: "PetsuitLegsRight", Pri: -15,
			Poses: ToMap(["KneelClosed", "Kneel", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			InheritColor: "Glow",
			NoOverride: true,
			NoDisplace: true,
		},
		{ Name: "GlowLeftLegs", Layer: "PetsuitLegsRight", Pri: -15,
			Poses: ToMap(["KneelClosed", "Kneel"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			InheritColor: "Glow",
			NoOverride: true,
			NoDisplace: true,
		},
	])
});


AddModel({
	Name: "ElitePetsuit",
	Folder: "LeatherPetsuit",
	Parent: "Petsuit",
	TopLevel: true,
	Categories: ["Restraints", "Cosplay"],
	Restraint: true,
	AddPose: ["HideArms", "EncaseArmLeft", "EncaseArmRight", "EncaseLegLeft", "EncaseLegRight", "ForceKneel", "Petsuit"],
	HideLayerGroups: ["PetsuitArms"],
	Layers: ToLayerMap([
		{ Name: "Arms", Layer: "BindForeArms", Pri: -15,
			Invariant: true,
			Poses: ToMap(["Front"]),
			InheritColor: "Suit",
		},
		{ Name: "ArmsBelts", Layer: "BindForeArms", Pri: -14.9,
			Invariant: true,
			TieToLayer: "Arms",
			NoOverride: true,
			Poses: ToMap(["Front"]),
			InheritColor: "Straps",
		},
		{ Name: "ArmsLaces", Layer: "BindForeArms", Pri: -14.8,
			Invariant: true,
			TieToLayer: "Arms",
			NoOverride: true,
			Poses: ToMap(["Front"]),
			InheritColor: "Laces",
		},
		{ Name: "ArmsHardware", Layer: "BindForeArms", Pri: -14.8,
			Invariant: true,
			TieToLayer: "Arms",
			NoOverride: true,
			Poses: ToMap(["Front"]),
			InheritColor: "Hardware",
		},
		{ Name: "Legs", Layer: "PetsuitLegsRight", Pri: -5,
			Poses: ToMap(["KneelClosed", "Kneel", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			InheritColor: "Suit",
		},
		{ Name: "LegsLaces", Layer: "PetsuitLegsRight", Pri: 15.2,
			TieToLayer: "Legs",
			NoOverride: true,
			Poses: ToMap(["KneelClosed", "Kneel", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			InheritColor: "Laces",
		},
		{ Name: "LegsHardware", Layer: "PetsuitLegsRight", Pri: 15.2,
			TieToLayer: "Legs",
			NoOverride: true,
			Poses: ToMap(["KneelClosed", "Kneel", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			InheritColor: "Hardware",
		},
		{ Name: "LegsBelts", Layer: "PetsuitLegsRight", Pri: 15.1,
			TieToLayer: "Legs",
			NoOverride: true,
			Poses: ToMap(["KneelClosed", "Kneel", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			InheritColor: "Straps",
		},
		{ Name: "LeftLegs", Layer: "PetsuitLegs", Pri: 15,
			Poses: ToMap(["KneelClosed", "Kneel"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			DisplaceAmount: 50,
			DisplacementInvariant: true,
			DisplaceLayers: ToMap(["Petsuit"]),
			DisplacementSprite: "PetsuitSquish",
			InheritColor: "Suit",
		},
		{ Name: "LeftLegsBelts", Layer: "PetsuitLegs", Pri: 15.1,
			NoOverride: true,
			Poses: ToMap(["KneelClosed", "Kneel"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			InheritColor: "Straps",
		},
		{ Name: "LeftLegsLaces", Layer: "PetsuitLegs", Pri: 15.2,
			TieToLayer: "LeftLegs",
			NoOverride: true,
			Poses: ToMap(["KneelClosed", "Kneel"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			InheritColor: "Laces",
		},
		{ Name: "LeftLegsHardware", Layer: "PetsuitLegs", Pri: 15.2,
			TieToLayer: "LeftLegs",
			NoOverride: true,
			Poses: ToMap(["KneelClosed", "Kneel"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			InheritColor: "Hardware",
		},
	])
});


AddModel({
	Name: "CyberPetsuit",
	Folder: "CyberPetsuit",
	Parent: "Petsuit",
	TopLevel: true,
	Categories: ["Restraints", "Cosplay"],
	Restraint: true,
	AddPose: ["HideArms", "EncaseArmLeft", "EncaseArmRight", "EncaseLegLeft", "EncaseLegRight", "ForceKneel", "Petsuit"],
	HideLayerGroups: ["PetsuitArms"],
	Filters: {
		Display: {"gamma":1,"saturation":1,"contrast":1.6500000000000001,"brightness":0.8,"red":1,"green":1,"blue":1,"alpha":1},
	},
	Layers: ToLayerMap([
		{ Name: "Arms", Layer: "BindForeArms", Pri: -15,
			Invariant: true,
			Poses: ToMap(["Front"]),
			InheritColor: "Suit",
		},
		{ Name: "ArmsBelts", Layer: "BindForeArms", Pri: -14.9,
			Invariant: true,
			TieToLayer: "Arms",
			NoOverride: true,
			Poses: ToMap(["Front"]),
			InheritColor: "Straps",
		},
		{ Name: "DisplayArms", Layer: "BindForeArms", Pri: -14.8,
			Invariant: true,
			TieToLayer: "Arms",
			NoOverride: true,
			Poses: ToMap(["Front"]),
			InheritColor: "Display",
		},
		{ Name: "Legs", Layer: "PetsuitLegsRight", Pri: -5,
			Poses: ToMap(["KneelClosed", "Kneel", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			InheritColor: "Suit",
		},
		{ Name: "UnitLegs", Layer: "PetsuitLegsRight", Pri: 15,
			TieToLayer: "Legs",
			Poses: ToMap(["KneelClosed", "Kneel", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			InheritColor: "Unit",
			HideWhenOverridden: true,
			HideOverrideLayer: "Skirt",
		},
		{ Name: "DisplayLegs", Layer: "PetsuitLegsRight", Pri: 15.2,
			TieToLayer: "UnitLegs",
			NoOverride: true,
			Poses: ToMap(["KneelClosed", "Kneel", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			InheritColor: "Display",
		},
		{ Name: "LegsBelts", Layer: "PetsuitLegsRight", Pri: 15.1,
			TieToLayer: "Legs",
			NoOverride: true,
			Poses: ToMap(["KneelClosed", "Kneel", "Hogtie"]),
			GlobalDefaultOverride: ToMap(["KneelClosed", "Hogtie"]),
			InheritColor: "Straps",
		},
		{ Name: "LeftLegs", Layer: "PetsuitLegs", Pri: 15,
			Poses: ToMap(["KneelClosed", "Kneel"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			DisplaceAmount: 50,
			DisplacementInvariant: true,
			DisplaceLayers: ToMap(["Petsuit"]),
			DisplacementSprite: "PetsuitSquish",
			InheritColor: "Suit",
		},
		{ Name: "LeftLegsBelts", Layer: "PetsuitLegs", Pri: 15.1,
			NoOverride: true,
			Poses: ToMap(["KneelClosed", "Kneel"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			InheritColor: "Straps",
		},
		{ Name: "UnitLeftLegs", Layer: "PetsuitOver", Pri: 15,
			Poses: ToMap(["KneelClosed", "Kneel"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			InheritColor: "Unit",
			HideWhenOverridden: true,
			HideOverrideLayer: "Skirt",
		},
		{ Name: "DisplayLeftLegs", Layer: "PetsuitOver", Pri: 15.2,
			TieToLayer: "UnitLeftLegs",
			NoOverride: true,
			Poses: ToMap(["KneelClosed", "Kneel"]),
			GlobalDefaultOverride: ToMap(["KneelClosed"]),
			InheritColor: "Display",
		},
	])
});
